import { DashboardResetPasswordPage } from "@dashboard/features/password-reset/ResetPasswordPage"
import { createFileRoute, redirect } from "@tanstack/react-router"
import { dashboardAppHostRedirectUrl } from "@utils/dashboardHost"
import { currentRequestHostname } from "@utils/dashboardHostRuntime"

type ResetPasswordSearch = {
  token?: string
}

export const Route = createFileRoute("/reset-password")({
  validateSearch: (search): ResetPasswordSearch => ({
    token: typeof search.token === "string" ? search.token : undefined,
  }),
  beforeLoad: async ({ location }) => {
    const redirectHref = dashboardAppHostRedirectUrl(await currentRequestHostname(), location.href)
    if (redirectHref) throw redirect({ href: redirectHref })
  },
  component: ResetPasswordRoute,
})

function ResetPasswordRoute() {
  const search = Route.useSearch()
  return <DashboardResetPasswordPage token={search.token} />
}
